export class ExtraFeeSummary {
    public amount?: string;
    public calculatedAmount?: string;
    public label?: string;
    public quantity?: number | string;
    public totalAmount?: string;


    constructor(amount: string, calculatedAmount: string, label: string, quantity: number | string, totalAmount: string) {
        this.amount = amount;
        this.calculatedAmount = calculatedAmount;
        this.label = label;
        this.quantity = quantity;
        this.totalAmount = totalAmount;
    }
}
